<template>
  <div class="profile px-8">
    <ApolloMutation
      class="settings-seo__header py-8"
      :mutation="mutation"
      :variables="mutationVariables"
      @done="updateComplete()"
      @loading="updateLoading = $event"
      @error="printError($event)"
      :update="updateCache"
    >
      <template v-slot="{ mutate }">
        <ProfileActions
          :disabled="!validForm || !dirty"
          @update="mutate()"
          root-name="Gestione Utenti"
          element-name="Modifica"
        />
      </template>
    </ApolloMutation>
    <ApolloQuery :query="query" :variables="{ id: $route.params.id }">
      <template slot-scope="{ result: { loading, error, data } }">
        <div class="py-10">
          <!-- Loading -->
          <div v-if="loading">Loading...</div>

          <!-- Error -->
          <div v-else-if="error">An error occured</div>

          <!-- Result -->
          <div v-else-if="data" class="result apollo">
            <ProfileFields
              v-bind="data.findUserByID"
              :update-loading="updateLoading"
              @valid="validForm = $event"
              @update="updateData"
              ref="profileFields"
            />
          </div>
        </div>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
import ProfileActions from '@/components/ProfileActions'
import ProfileFields from '@/components/ProfileFields'
import GET_USER from '@/graphql/GetUser.gql'
import UPDATE_USER from '@/graphql/UpdateUser.gql'

export default {
  components: {
    ProfileActions,
    ProfileFields,
  },

  data() {
    return {
      dirty: false,
      validForm: false,
      updateLoading: false,
      query: GET_USER,
      mutation: UPDATE_USER,
      mutationVariables: {
        id: this.$route.params.id,
        data: {
          email: '',
          displayName: '',
          password: '',
          isAdmin: false,
        },
      },
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.shouldExit(next)
  },

  beforeRouteLeave(to, from, next) {
    this.shouldExit(next)
  },

  methods: {
    updateComplete() {
      this.updateLoading = false
      this.markAsClean()

      this.$refs.profileFields.resetPasswordFields()
    },

    printError(err) {
      this.updateComplete()
      console.error(err)
    },

    updateCache(store, res) {
      let data = null
      const query = {
        query: this.query,
      }

      try {
        data = store.readQuery(query)
      } catch {
        // empty cache
      }

      if (data) {
        data.me = res.data.updateUser
        store.writeQuery({ ...query, data })
      }
    },

    updateData(event) {
      if (event.dirty) {
        this.markAsDirty()
      } else {
        this.markAsClean()
      }

      Object.keys(event.modelData).forEach(key => {
        this.$set(this.mutationVariables.data, key, event.modelData[key])
      })
    },

    markAsClean() {
      this.dirty = false
    },

    markAsDirty() {
      this.dirty = true
    },

    shouldExit(next) {
      if (this.dirty) {
        if (
          confirm(
            'Uscire dalla pagina? Alcune modifiche non sono state salvate.',
          )
        ) {
          this.markAsClean()
          next()
          return
        } else {
          next(false)
          return
        }
      }

      next()
    },
  },
}
</script>
